import moment from 'moment-timezone'
import type { TDateRange, TIcsDashboardData } from '../types'

export const splitEtDataByWeek = (
  dailyEt: TIcsDashboardData['dailyEtLastWeek'],
  thisWeekRange: TDateRange,
  nextWeekRange: TDateRange,
  timezone: string,
): {
  dailyEtLastWeek: TIcsDashboardData['dailyEtLastWeek']
  dailyEtNextWeek: TIcsDashboardData['dailyEtNextWeek']
} => {
  const thisWeekStart = moment.tz(thisWeekRange.dateFrom, timezone)
  const thisWeekEnd = moment.tz(thisWeekRange.dateTo, timezone)
  const nextWeekStart = moment.tz(nextWeekRange.dateFrom, timezone)
  const nextWeekEnd = moment.tz(nextWeekRange.dateTo, timezone)

  const filterByRange = (
    points: {
      timestamp: string
      value: number | string | null
    }[],
    start: moment.Moment,
    end: moment.Moment,
  ) => {
    return points.filter((p) => {
      const ts = moment.tz(p.timestamp, timezone)

      return ts.isSameOrAfter(start) && ts.isSameOrBefore(end)
    })
  }

  const dailyEtLastWeek = dailyEt.map((zone) => ({
    zone_id: zone.zone_id,
    blockData: {
      block_ids: zone.blockData.block_ids,
      kc: filterByRange(zone.blockData.kc, thisWeekStart, thisWeekEnd),
      etc: filterByRange(zone.blockData.etc, thisWeekStart, thisWeekEnd),
      rain: filterByRange(zone.blockData.rain, thisWeekStart, thisWeekEnd),
    },
  }))

  const dailyEtNextWeek = dailyEt.map((zone) => ({
    zone_id: zone.zone_id,
    blockData: {
      block_ids: zone.blockData.block_ids,
      kc: filterByRange(zone.blockData.kc, nextWeekStart, nextWeekEnd),
      etc: filterByRange(zone.blockData.etc, nextWeekStart, nextWeekEnd),
      rain: filterByRange(zone.blockData.rain, nextWeekStart, nextWeekEnd),
    },
  }))

  return { dailyEtLastWeek, dailyEtNextWeek }
}
